import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// components
import SidebarView from '../../components/Sidebar';

const SidebarPropTypes = {
  children: PropTypes.node, // Child components and elements passed to Sidebar
  toggle: PropTypes.bool.isRequired, // The current state of the vehicle selector component (open/closed)
  isMobile: PropTypes.bool.isRequired, // True when the app is loaded on a handheld sized device
  directionsLoaded: PropTypes.bool.isRequired, // If directions have successfully returned from service
};

const SidebarDefaultProps = {
  children: null,
};

// eslint-disable-next-line react/destructuring-assignment
const Sidebar = props => <SidebarView {...props}>{props.children}</SidebarView>;

Sidebar.propTypes = SidebarPropTypes;

Sidebar.defaultProps = SidebarDefaultProps;

const mapStateToProps = state => ({
  isMobile: state.App.isMobile,
  toggle: state.Vehicle.toggle,
  directionsLoaded: state.Directions.directionsLoaded,
});

export default connect(
  mapStateToProps,
  null,
)(Sidebar);
